import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Menu } from '@material-ui/core';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import Button from './Basic/Button';
import AppBarMenuItem from './AppBarMenuItem';
import appBarItemsList from '../helpers/app-bar-items-list';
import DarkThemeToggle from './DarkThemeToggle';
import {
  extractFromBrackets,
  getNameInitials,
  nameLimiter,
} from '../helpers/text-modifers';

const useStyles = makeStyles((theme) => ({
  account: {
    // marginLeft: 'auto',
  },
  accountBtn: {
    marginLeft: 6,
    padding: 0,
    minWidth: 'initial',
    width: 42,
    height: 42,
    borderRadius: '50%',
    marginRight: '-6px',

    [theme.breakpoints.up('md')]: {
      width: 48,
      height: 48,
      marginRight: '-3px',
    },
  },
  menuUserName: {
    margin: 0,
    padding: theme.spacing(1, 2, 1, 2),
    fontWeight: 500,
    textTransform: 'capitalize',
    '&:focus': {
      outline: 'none',
    },
    '&:active': {
      outline: 'none',
    },
  },
  menuUserClientId: {
    margin: 0,
    padding: theme.spacing(1, 2, 1, 2),
    fontWeight: 500,
    textTransform: 'uppercase',
    marginTop: '-8px',
    '&:focus': {
      outline: 'none',
    },
    '&:active': {
      outline: 'none',
    },
  },
  NameInitials: {
    width: 34,
    height: 34,
    backgroundColor: 'transparent',
    color: 'var(--color-colorPrimary-main)',
    border: '1px solid var(--color-colorPrimary-main)',
    fontSize: '0.8rem',

    [theme.breakpoints.up('md')]: {
      width: 38,
      height: 38,
      fontSize: '0.875rem',
    },
  },
}));

const getUserInitials = (user) => {
  const logged = user && user.name ? true : false;

  if (!logged) {
    return '';
  }

  const nameInitials = getNameInitials(user?.name);

  return nameInitials;
};

const NameInitials = ({ user }) => {
  const classes = useStyles();
  const nameInitials = getUserInitials(user);

  return <Avatar className={classes.NameInitials}>{nameInitials}</Avatar>;
};

const getUserName = (user) => {
  const logged = user && user.name ? true : false;

  if (!logged) {
    return '---';
  }

  const [username, usernameDotted] = nameLimiter(user.name?.toLowerCase(), 33);

  return usernameDotted ? usernameDotted : username;
};

const AccountMenu = ({ authLogout, user }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const userName = getUserName(user);
  const clientId = extractFromBrackets(user?.displayName || '');

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div className={classes.account}>
        <Button
          aria-label="menu"
          onClick={handleClick}
          color="primary"
          className={classes.accountBtn}
          capitalized
        >
          <NameInitials user={user} />
        </Button>
      </div>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <p className={classes.menuUserName}>{userName}</p>

        {clientId ? (
          <p className={classes.menuUserClientId}>({clientId})</p>
        ) : (
          ''
        )}

        {appBarItemsList.map(({ name, href = '', icon = null }) => (
          <AppBarMenuItem
            key={name}
            title={name}
            href={href}
            icon={icon}
            handleMenuClose={handleClose}
          />
        ))}
        <DarkThemeToggle />
        <AppBarMenuItem
          title="Logout"
          onClick={authLogout}
          icon={<ExitToAppOutlinedIcon />}
        />
      </Menu>
    </>
  );
};

AccountMenu.defaultProps = {
  user: {},
};

AccountMenu.propTypes = {
  authLogout: PropTypes.func.isRequired,
  user: PropTypes.shape({}),
};

export default AccountMenu;
